export default __webpack_public_path__ + "static/media/information--camera--g3.44300682.png";